import Vue from 'vue';
import {
  Menu,
  MenuItem,
  Submenu,
  MessageBox,
  Breadcrumb,
  BreadcrumbItem,
  Loading,
  Row,
  Col,
  Table,
  TableColumn,
  Form,
  FormItem,
  Button,
  ButtonGroup,
  Badge,
  Tree,
  Pagination,
  Dialog,
  Select,
  Option,
  Cascader,
  Input,
  Alert,
  Tag,
  Checkbox,
  CheckboxGroup,
  Tooltip,
  Switch,
  Radio,
  RadioGroup,
  Tabs,
  TabPane,
  Upload,
  DatePicker
} from 'element-ui';

Vue.use(Loading);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Row);
Vue.use(Col);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Badge);
Vue.use(Tree);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(Input);
Vue.use(Alert);
Vue.use(Tag);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Tooltip);
Vue.use(Switch);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Upload);
Vue.use(DatePicker);

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;



// WEBPACK FOOTER //
// ./src/plugins/element.js